import { PUBLIC_LOCAL_STORAGE_VERSION } from '@/consts'
import { decrypt, encrypt, logger, mask } from '@/lib/client'
import type { IAccount, IAuthentication } from '@/types/account'
import type { ICheckoutPersonalData } from '@/types/checkout'
import { persistentAtom } from '@nanostores/persistent'

const EMPTY_ACCOUNT: IAccount & IAuthentication = {
  _id: '',
  email: '',
  token: '',
}

const authentication = persistentAtom<IAccount & IAuthentication>(
  `dc_authentication/${PUBLIC_LOCAL_STORAGE_VERSION}`,
  EMPTY_ACCOUNT,
  {
    // encode: JSON.stringify,
    // decode: JSON.parse,
    encode: (value) => {
      return btoa(encrypt(JSON.stringify(value)))
    },
    decode: (value) => {
      try {
        return JSON.parse(decrypt(atob(value)))
      } catch (error) {
        logger(
          'STORE AUTHENTICATION',
          JSON.stringify({
            name: error?.name,
            message: error?.message,
          }),
        )
        return value
      }
    },
  },
)

const store = { authentication }

const signin = (account: IAccount & IAuthentication) => {
  authentication.set(account)
}

const refresh = ({ token, refresh_token }: IAuthentication) => {
  authentication.set({ ...authentication.get(), token, refresh_token })
}

const signout = () => {
  authentication.set(EMPTY_ACCOUNT)
}

const get = (): ICheckoutPersonalData => {
  const student = authentication.get()
  const data: ICheckoutPersonalData = {
    name: student?.name || '',
    email: student?.email || '',
    phone: mask(student?.telephone || '', 'phone'),
    document: mask(
      student?.document || '',
      (student?.document || '').length > 11 ? 'cnpj' : 'cpf',
    ),
    type: student?.type || 'individual',
    birthdate: student?.birthdate || '',
    zipcode: mask(student?.address?.zipcode || '', 'cep'),
    address: student?.address?.street || '',
    number: student?.address?.number || '',
    complement: student?.address?.addressComplement || '',
    district: student?.address?.district || '',
    state: student?.address?.state || '',
    city: student?.address?.city || '',
  }
  return data
}

const update = (data: IAccount) => {
  authentication.set({ ...authentication.get(), ...data })
}

const actions = { signout, signin, refresh, get, update }

export { store, actions }
